<template>
  <div class="w100 card-shadow bg-w">
    <p class="pb10 pt20 font-18 tx-c">可用服务</p>
    <TabBar v-model="tabIndex" :tab-data="tabData"></TabBar>

    <div class="w100 pt20 pb20 pl20 pr20" v-loading="loading">
      <el-row :gutter="20" v-loading="loading">
        <el-col class="mb10" :span="6" v-for="(item, index) in list" :key="index">
          <AppCard :data="item" />
        </el-col>
        <el-col class="pt20 pb20 tx-c grey font-14" :span="24" v-show="list.length == 0">暂无可用服务</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import TabBar from "@/components/public/TabBar";
import AppCard from "@/components/public/AppCard";

export default {
  name: "OfficeServeList",
  components: {
    TabBar,
    AppCard,
  },
  props: [],
  data() {
    return {
      loading: false,
      tabIndex: "0",
      tabData: [
        {
          index: "0",
          name: "推荐",
        },
        {
          index: "1",
          name: "学工",
        },
        {
          index: "2",
          name: "人事",
        },
        {
          index: "3",
          name: "收藏",
        },
      ],
      list: [],
    };
  },
  computed: {
    url() {
      switch (this.tabIndex) {
        case "0":
          return "/hallServe/servePermitList";
        case "1":
          return "/hallServe/servePermitList";
        case "2":
          return "/hallServe/servePermitList";
        case "3":
          return "/personal/collection/getAllData";
        default:
          break;
      }
    },
  },
  created() {},
  mounted() {
    this.fetchList();
  },
  destroyed() {},
  methods: {
    fetchList() {
      this.loading = true;
      // this.list = [];
      let sift = {};
      sift.pageNum = 1;
      sift.pageSize = 100;
      if (this.tabIndex == 0) {
        sift.recommend = 1;
      } else if (this.tabIndex == 1) {
        sift.serveSubject = "7984587f-c5e6-42ce-89e1-1376acdedebf";
      } else if (this.tabIndex == 2) {
        sift.serveSubject = "1ca3ac64-b06d-4ff7-8487-2b34ee069bd8";
      }

      if (this.tabIndex == 3) {
        this.$http
          .get(this.url, { params: sift })
          .then(({ data }) => {
            if (data.resCode == 0) {
              this.list = data.resData.list.map((val) => {
                return {
                  id: val.serveId,
                  serveName: val.serveName,
                  serveType: Number(val.serveType),
                  serveTitle: val.serveTitle,
                  appraise: val.score,
                  favoriteCount: val.count,
                  serveImage: val.processLogoDl,
                  collection: val.serveCollect,
                  interfaceUrl: val.interfaceUrl,
                  linkUrl: val.interfaceUrl,
                  // 新增所属部门列表字段
                  deptName: val.deptNameIds
                    ? val.deptNameIds.map((val) => val.deptName).join("、")
                    : "-",
                };
              });
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.$http
          .post(this.url, this.$qs.stringify(sift))
          .then(({ data }) => {
            if (data.resCode == 0) {
              this.list = data.resData.list.map((val) => {
                return {
                  id: val.id,
                  serveName: val.serveName,
                  serveType: Number(val.serveType),
                  serveTitle: this.serveSubjectToString(val.serveSubjectList),
                  appraise: val.commentScore,
                  favoriteCount: val.storeCount,
                  serveImage: val.logo,
                  collection: val.serveCollect,
                  interfaceUrl: val.interfaceUrl,
                  linkUrl: val.linkUrl,
                  // 新增所属部门列表字段
                  deptName: val.deptNameIds
                    ? val.deptNameIds.map((val) => val.deptName).join("、")
                    : "-",
                };
              });
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    serveSubjectToString(arr) {
      const newArr = arr.map((val) => val.subjectName);
      return newArr.join("、");
    },
    changeTabIndex(index) {
      this.tabIndex = index;
      this.$nextTick(() => {
        this.fetchList();
      });
    },
  },
  watch: {
    tabIndex() {
      this.fetchList();
    },
  },
  filters: {},
};
</script>

<style scoped>
</style>
